
	/**
	 * @description
	 *  Modelo de seguimiento de un pedido.
	 *
	 * @see gigot-backend/Models/Orders/Order.cs
	 */

export class OrderTracking {

	;

	/**
	 * @description
	 *	Construye un seguimiento de pedido con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un seguimiento con valores por defecto.
	 *	Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un seguimiento de pedido vacío.
	 */
	public static empty(): OrderTracking {
		const orderTracking: OrderTracking = new OrderTracking();
		return orderTracking;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderTracking
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderTracking: OrderTracking): OrderTracking {
		if (!anemicOrderTracking) return undefined;
		const orderTracking: OrderTracking = OrderTracking.empty();
		return orderTracking;
	}
}
